/**
 * The module's one rhythm, in milliseconds. `short` for elements appearing
 * after a load, `medium` for page changes, `long` as the ceiling for a
 * staggered group so a 100-row table still finishes promptly.
 */
export interface MotionDurations {
  short: number;
  medium: number;
  long: number;
}

export const MOTION_DURATIONS: MotionDurations = {
  short: 150,
  medium: 250,
  long: 400,
};

/** For tests: every animation completes on the next frame. */
export const ZERO_MOTION_DURATIONS: MotionDurations = {
  short: 0,
  medium: 0,
  long: 0,
};

/** Gap between staggered children before the `long` ceiling clamps it. */
export const STAGGER_STEP_MS = 40;
